import React, { useState, useEffect } from "react";
import logo1 from "./../../assets/haryana-govtswarnim.png";
import logo2 from "./../../assets/haryana-govt1_1.png";
import logo3 from "./../../assets/emblem-black.png";
import leftLogo from "./../../assets/logo.jpg";
import secr from "./../../assets/screen_reader_icon.gif";

import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { FaBookOpenReader, FaMobileScreen } from "react-icons/fa6";
import { FaBookReader, FaSearch } from "react-icons/fa";
const searchItems = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about-us" },

  { name: "Products - Field Crops", path: "/products/field-crops" },
  {
    name: "Products - Field Crops - Rabi Crops",
    path: "/products/field-crops/rabi-crops",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Wheat",
    path: "/products/field-crops/rabi-crops/wheat",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Gram",
    path: "/products/field-crops/rabi-crops/gram",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Lentil",
    path: "/products/field-crops/rabi-crops/lentil",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Barley",
    path: "/products/field-crops/rabi-crops/barley",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Toria",
    path: "/products/field-crops/rabi-crops/toria",
  },
  {
    name: "Products - Field Crops - Rabi Crops - Mustard",
    path: "/products/field-crops/rabi-crops/mustard",
  },

  {
    name: "Products - Field Crops - Kharif Crops",
    path: "/products/field-crops/kharif-crops",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Cotton",
    path: "/products/field-crops/kharif-crops/cotton",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Guar",
    path: "/products/field-crops/kharif-crops/guar",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Bajra",
    path: "/products/field-crops/kharif-crops/bajra",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Paddy",
    path: "/products/field-crops/kharif-crops/paddy",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Arhar",
    path: "/products/field-crops/kharif-crops/arhar",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Til",
    path: "/products/field-crops/kharif-crops/til",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Moth",
    path: "/products/field-crops/kharif-crops/moth",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Moong",
    path: "/products/field-crops/kharif-crops/moong",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Urad",
    path: "/products/field-crops/kharif-crops/urad",
  },
  {
    name: "Products - Field Crops - Kharif Crops - Maize",
    path: "/products/field-crops/kharif-crops/maize",
  },

  { name: "Products - Vegetables", path: "/products/vegetables" },
  {
    name: "Products - Rabi Crops Vegetables",
    path: "/products/vegetables/rabi-crops-Vegetables",
  },
  {
    name: "Products - Kharif Crops Vegetables",
    path: "/products/vegetables/kharif-crops-Vegetables",
  },

  { name: "Production - Stages of Production", path: "/production/stages" },
  { name: "Production - Seed Production", path: "/production/seed-production" },
  { name: "Production - Seed Processing", path: "/production/seed-processing" },
  {
    name: "Production - Incentives/Facilities to Growers",
    path: "/production/incentives",
  },
  {
    name: "Marketing - Sale Rate of Rabi Seeds - Crops",
    path: "/marketing/rabi-seeds",
  },
  {
    name: "Marketing - Sale Rate of Rabi Seeds - Vegetables",
    path: "/marketing/rabi-vegetables",
  },
  {
    name: "Marketing - Sale Rate of Kharif Seeds - Crops",
    path: "/marketing/kharif-seeds",
  },
  {
    name: "Marketing - Sale Rate of Kharif Seeds - Vegetables",
    path: "/marketing/kharif-vegetables",
  },
  {
    name: "Marketing - Availability of Rabi Seeds",
    path: "/marketing/rabi-availability",
  },
  {
    name: "Marketing - Availability of Kharif Seeds",
    path: "/marketing/kharif-availability",
  },
  { name: "Marketing - Regional Offices", path: "/marketing/offices" },
  {
    name: "Marketing - List of Sale Counters",
    path: "/marketing/sale-counters",
  },
  {
    name: "Marketing - Sale Rate of Agro Chemicals/Pesticides/Weedicides/Insecticides",
    path: "/marketing/sale-rate-agro",
  },
  {
    name: "Marketing - Citizen Services Delivered",
    path: "/marketing/citizen-services",
  },
  {
    name: "Marketing - Manner of Execution of Subsidy Programme",
    path: "/marketing/subsidy-program",
  },
  {
    name: "Marketing - Allocation of Wheat, Gram, Mustard, and Barley Seeds",
    path: "/marketing/seeds-allocation",
  },
  { name: "Engineering", path: "/engineering" },
  { name: "Directory - Directors", path: "/directory/directors" },
  { name: "Directory - Head Offices", path: "/directory/head-offices" },
  { name: "Directory - Regional Offices", path: "/directory/regional-offices" },
  { name: "Finance", path: "/finance" },
  { name: "Tenders", path: "/tenders" },
  {
    name: "Administration - Service Rules",
    path: "/administration/service-rules",
  },
  { name: "Administration - Circulars", path: "/administration/circulars" },
  {
    name: "Administration - Forms and Procedures",
    path: "/administration/forms",
  },
  {
    name: "Administration - Purchase Manuals",
    path: "/administration/manuals",
  },
  {
    name: "Administration - Notifications and Orders",
    path: "/administration/notifications",
  },
  {
    name: "Administration - Placement Announcements",
    path: "/administration/placement",
  },
  { name: "Administration - Policies", path: "/administration/policies" },
  {
    name: "Administration - Transfers and Promotions",
    path: "/administration/transfers",
  },
  {
    name: "Administration - Miscellaneous",
    path: "/administration/miscellaneous",
  },
  {
    name: "Administration - Anti Stubble Burning Campaign",
    path: "/administration/anti-stubble-buring-campaign",
  },
  { name: "Contact Us", path: "/contact-us" },
  {
    name: "Internal Complaint Committee",
    path: "/internal-complaint-committee",
  },
  { name: "Audit Cell", path: "/audit-cell" },
  { name: "Quality Control", path: "/quality-control" },
  { name: "Agreements", path: "/agreements" },
  { name: "Grower Agreements", path: "/agreements" },
  { name: "SERVICES", path: "/services" },
  { name: "RTI", path: "/rti" },
  { name: "RTI Application Form", path: "/rti/application-form" },
  { name: "RTI List of Authorities", path: "/rti/list-of-authorities" },
  { name: "RTI Fees", path: "/rti/fees" },
  { name: "RTI Replies", path: "/rti/rti-replies" },
  { name: "RTI Proactive Disclosure", path: "/rti/proactive-disclouser" },
  { name: "Photo Gallery", path: "/photo-gallery" },
  { name: "Accessibility Statement", path: "/accessibility-statement" },
  { name: "Website Policies", path: "/website-policies" },
  { name: "Terms and Conditions", path: "/terms-and-conditions" },
  { name: "Disclaimer", path: "/disclaimer" },
  { name: "Help", path: "/help" },
  { name: "Feedback", path: "/feedback" },
  { name: "Sitemap", path: "/sitemap" },
  { name: "Schemes", path: "/schemes" },
  { name: "Screen Access Reader", path: "/screen-access-reader" },
];
const Header = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState("en");
  const [fontSize, setFontSize] = useState(15);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (query.length > 0) {
      const filtered = searchItems.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  }, [query]);


  const handleSuggestionClick = (path) => {
    navigate(path);
    setQuery(""); 
    setSuggestions([]); 
  };
  useEffect(() => {
    document.body.classList.toggle("dark-mode-body", darkMode);
    document.body.style.fontSize = `${fontSize}px`;
  }, [darkMode, fontSize]);

  const toggleDarkMode = () => setDarkMode(!darkMode);
  // const toggleLanguage = () => setLanguage(language === 'en' ? 'hi' : 'en');
  const resetFontSize = () => setFontSize(16);
  const decreaseFontSize = () =>
    setFontSize((prevSize) => Math.max(prevSize - 2, 12));
  const increaseFontSize = () =>
    setFontSize((prevSize) => Math.min(prevSize + 2, 18));
  return (
    <div className={darkMode ? "dark-mode" : "light-mode"}>
      <div className={`utility-bar  ${darkMode ? "text-white" : "text-dark"}`}>
        <div className="text-size-controls ms-auto me-2">
          <span className="search-box d-inline-block">
            <input
              type="text"
              className="border rounded-start ps-2"
              placeholder="Search....."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              aria-label="Search"
            />
            <button className="btn-sm btn-primary " type="button" style={{borderRadius:"0",padding:" 0 3px"}}>
              <FaSearch />
            </button>

            {suggestions.length > 0 && (
              <ul className="suggestions-list position-absolute bg-white shadow rounded mt-1 ">
                {suggestions.map((item, index) => (
                  <li
                    key={index}
                    className="p-2 suggestion-item"
                    onClick={() => handleSuggestionClick(item.path)}
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
          </span>
          <a href="#main-content" className="skip-to-main mx-2">
            Skip to main content
          </a>
          <a className="mx-2" onClick={decreaseFontSize}>
            A-
          </a>
          <a className="mx-2" onClick={resetFontSize}>
            A
          </a>
          <a className="mx-2" onClick={increaseFontSize}>
            A+
          </a>

          <Link to={"/screen-access-reader"}>
            {" "}
            <img className="" src={secr} />
          </Link>
          <a className="mx-2 " onClick={toggleDarkMode}>
            {darkMode ? "Light Mode" : "Dark Mode"}
          </a>

          <a id="google_translate_element" className="d-inline-block ms-2"></a>
        </div>
      </div>

      <header
        className={`header py-2 ${
          darkMode
            ? "bg-secondary text-white"
            : "custom-bg-lightyellow text-dark"
        }`}
      >
        <div className="container-fluid floathead d-flex align-items-center justify-content-between">
          <div className="logo-left">
            <img src={leftLogo} alt="Left Logo" className="img-fluid img1" />
          </div>

          <div className="logos-right d-flex justify-content-end align-items-center">
            <img
              src={logo1}
              alt="Logo 1"
              className="img-fluid img2 mx-2"
              style={{ maxWidth: "120px" }}
            />
            <img
              src={logo2}
              alt="Logo 2"
              className="img-fluid img3 mx-2"
              style={{ maxWidth: "80px" }}
            />
            <img
              src={logo3}
              alt="Logo 3"
              className="img-fluid img4 mx-2"
              style={{ maxWidth: "80px" }}
            />
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
